export default [
  {
    path: '/note',
    name: 'notelist',
    component: () => import('@/pages/notelist/index.vue'),
    meta: { name: '设备管理' }
  },
  {
    path: '/Taskmanagement',
    name: 'Taskmanagement',
    component: () => import('@/pages/notelist/Taskmanagement/index.vue'),
    meta: { name: '任务管理' }
  },
  {
    path: '/Taskmanagement/details/:id',
    name: 'Taskmanagementdetails',
    component: () => import('@/pages/notelist/Taskmanagement/Taskmanagementdetails.vue'),
    meta: { name: ['任务管理', '发送明细'] }
  },
  {
      path: '/Robotics',
      name: 'Robotics',
      component: () => import('@/pages/Robotics/index.vue'),
      meta: { name: '机器人管理' }
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/pages/Robotics/notifications/index.vue'),
      meta: { name: '推送消息管理' }
    },
    {
      path: '/notifications/details/:id',
      name: 'notificationdetails',
      component: () => import('@/pages/Robotics/notifications/notificationdetails/index.vue'),
      meta: { name: ['推送消息管理', '推送详情'] }
    }
]



// WEBPACK FOOTER //
// ./src/router/customManage/note.js